const xvnode = (sess, cfg, graph, node, pg, subj) => {
  const { a, ul, li } = cfg.h(pg, node)

  return (
    ul('.:ui-root', subj.tags.map(tag => (
      li('.:ui-listitem', [
        a('.:ui-listitem-link', {
          href: `/tag/index.html#${tag}`,
          title: tag
        }, tag)
      ])
    )))
  )
}

export default {
  type: 'uitagslist',
  xvnode
}
